const data = [
  {
    id: 1,
    year: '2026',
    date: 'Jun 2026',
    category: 'E-Commerce',
    title: 'CapMist Store',
    image: 'capmist-store.png',
    technologies: ['React', 'TypeScript', 'Vite', 'Tailwind CSS', 'Supabase'],
    desc: 'CapMist Store es una plataforma de e-commerce enfocada en la venta de gorras, sneakers y streetwear. Desarrollé una experiencia moderna inspirada en GOAT y StockX, incorporando catálogo dinámico, gestión de inventario, autenticación de usuarios, carrito de compras y una interfaz optimizada para dispositivos móviles.',
    links: {
      code: '',
      page: 'https://capmist.netlify.app/',
    },
  },
  {
    id: 3,
    year: '2024',
    date: '11/2/2024',
    category: 'WEB DESIGN',
    title: 'Mi Portafolio',
    image: 'portafolio.webp',
    technologies: [
      'PWA',
      'React',
      'CSS Modules',
      'Responsive',
      'Netlify',
      'HTML',
      'JS',
      'react-transition-group',
      'Eslint',
      'Prettier',
    ],
    desc: `Este proyecto me tomó mucho trabajo solo para poder expresar lo que hago y lo que me gusta hacer. Espero que te guste <3.`,
    links: {
      code: '',
      page: '',
    },
  },
  {
    id: 2,
    year: '2023',
    date: '15/1/2023',
    category: 'WEB DESIGN',
    title: 'E-commerce',
    image: 'E-commerce.webp',
    technologies: ['Vercel', 'Responsive', 'HTML', 'CSS', 'JS'],
    desc: 'Lumine Store es tu destino definitivo para explorar la fascinante cultura japonesa y el emocionante universo del anime. Con una amplia gama de productos auténticos, desde mercancía exclusiva de tus animes favoritos hasta artículos tradicionales japoneses, Lumine Store ofrece una experiencia de compra estéticamente agradable, impulsada por tecnologías como JavaScript, HTML, CSS, y Vercel para despliegues rápidos y confiables. Únete a la comunidad apasionada, descubre detalles informativos sobre cada producto y lleva a casa la magia de Japón con Lumine Store hoy mismo.',
    links: {
      code: 'https://github.com/AsheeOF/E-commerce',
      page: 'https://e-commerce-asheeof.vercel.app/',
    },
  },
  {
    id: 4,
    year: '2022',
    date: '26/12/2022',
    category: 'WEB DESIGN',
    title: 'Encriptador de Texto',
    image: 'Encriptador.webp',
    technologies: ['HTML', 'CSS', 'JS'],
    desc: 'Uno de mis primeros proyectos consistió en crear un cifrador de texto utilizando JavaScript. Fue durante mis primeros pasos en el mundo de la programación y el desarrollo.',
    links: {
      code: '',
      page: '',
    },
  },
  {
    id: 6,
    year: '2022',
    date: '5/1/2023',
    category: 'DEVELOPMENT',
    title: 'Relog App',
    image: 'Relog-Digital.webp',
    technologies: ['HTML', 'CSS', 'JS', 'Vercel'],
    desc: '🕰️✨ Un proyecto de reloj digital que fusiona la precisión del tiempo con la magia del arte en JavaScript. Cada segundo es una pincelada de innovación, mientras los números bailan en armonía, creando un lienzo temporal único. ¡Tiempo nunca antes visto con un toque creativo! ⏳🎨',
    links: {
      code: null,
      page: 'https://relog-digital.vercel.app/',
    },
  },
  {
    id: 5,
    year: '2026',
    date: '21/04/26',
    category: 'WEB DESIGN',
    title: 'Sal y Piedra',
    image: 'sal-y-piedra.png',
    technologies: ['HTML', 'CSS', 'JS', 'Vercel', 'TypeScript'],
    desc: '"Desarrollé el sitio web de Sal y Piedra, un restaurante enfocado en la cocina xalapeña con una experiencia visual cálida y elegante. El objetivo principal fue transmitir la esencia del lugar: tradición, calidad y una vista única, desde el primer impacto visual."',
    links: {
      code: '',
      page: 'https://sal-y-piedra-web-desing.vercel.app/',
    },
  },
  {
    id: 7,
    year: '',
    date: '',
    category: 'APPLICATION',
    title: 'Coming soon',
    image: 'coming-soon.webp',
    technologies: [],
    desc: '"Coming soon, more projects on the horizon... Stay tuned for a symphony of innovation! 🚀✨ #FutureProjects"',
    links: {
      code: '',
      page: '',
    },
  },
  {
    id: 8,
    year: '',
    date: '',
    category: 'APPLICATION',
    title: 'Coming soon',
    image: 'coming-soon.webp',
    technologies: [],
    desc: '"Coming soon, more projects on the horizon... Stay tuned for a symphony of innovation! 🚀✨ #FutureProjects"',
    links: {
      code: '',
      page: '',
    },
  },
];

export default data;
